import type { SVGProps } from "react";
export interface RadiationCircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RadiationCircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RadiationCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M13.321 14.742c.43-.095.884.072 1.15.438l.278.38.279.383.277.382.278.382a1.125 1.125 0 0 1-.41 1.67 7.15 7.15 0 0 1-6.346 0 1.126 1.126 0 0 1-.41-1.67l.557-.764.276-.383.279-.38.124-.146a1.13 1.13 0 0 1 1.207-.235 3.04 3.04 0 0 0 2.28 0zM8.158 5.996a1.127 1.127 0 0 1 1.544.542l.192.433.191.43.194.43.192.433c.21.473.071 1.028-.337 1.346a3.03 3.03 0 0 0-1.138 1.968A1.124 1.124 0 0 1 8 12.54l-.942.1-.47.048-.47.05a1.127 1.127 0 0 1-1.24-1.19 7.1 7.1 0 0 1 .942-3.117l.217-.352a7.1 7.1 0 0 1 2.015-2.02zm6.854-.079c.317-.092.66-.04.936.142a7.1 7.1 0 0 1 2.232 2.372l.197.365c.433.86.685 1.796.745 2.752a1.124 1.124 0 0 1-1.24 1.19l-.47-.05-.47-.049-.942-.1a1.125 1.125 0 0 1-.996-.961 3 3 0 0 0-.243-.834l-.133-.26a3 3 0 0 0-.762-.874 1.126 1.126 0 0 1-.337-1.346l.192-.432.194-.43.191-.431.192-.433.057-.11c.145-.246.38-.43.657-.51Zm-3.511 5.71a.62.62 0 0 0-.127.372l.014.126a.6.6 0 0 0 .113.246zm.998.744a.6.6 0 0 0 .113-.246l.014-.126-.014-.126a.6.6 0 0 0-.113-.246zM13.624 12a1.625 1.625 0 0 1-3.241.167L10.376 12l.007-.165A1.626 1.626 0 0 1 12 10.374l.165.01c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
